module.exports = __webpack_public_path__ + "static/img/appletLogo.853f50d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/appletLogo.jpg
// module id = oJBS
// module chunks = 1